const detectIE = () => {
    const ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …
    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    const edge = ua.indexOf('Edge/');
    const rv = ua.indexOf('rv:');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    if (trident > 0) {
        // IE 11 => return version number
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
};
const supportFlash = () => { // 是否支持Flash
    let flashAct;
    let sflash;
    if (navigator.mimeTypes.length > 0) {
        flashAct = navigator.mimeTypes['application/x-shockwave-flash'];
        return flashAct !== undefined ? flashAct.enabledPlugin !== undefined : false;
    } else if (window.ActiveXObject) {
        try {
            new ActiveXObject('ShockwaveFlash.ShockwaveFlash'); //eslint-disable-line
            return true;
        } catch (oError) {
            return false;
        }
    } else {
        if (navigator.plugins && navigator.plugins.length > 0) {
            sflash = navigator.plugins['Shockwave Flash'];
            return sflash? true : false; //eslint-disable-line
        }
        return false;
    }
};
// 获取谷歌版本
const googleVersion = () => {
    const agent = window.navigator.userAgent.toLowerCase();
    const browserNum = agent.match(/chrome\/[\d.]+/gi);
    return parseInt((browserNum + '').replace(/[^0-9.]/ig, ''), 10); // eslint-disable-line
};

// 判断win系统版本
const getWinVersion = function () {
    const version = navigator.userAgent;
    if (version.indexOf('Windows NT 5.0') !== -1) {
        return 'windows 2000';
    } else if (version.indexOf('Windows NT 5.1') !== -1) {
        return 'windows xp';
    } else if (version.indexOf('Windows NT 5.2') !== -1) {
        return 'windows 2003';
    } else if (version.indexOf('Windows NT 6.0') !== -1) {
        return 'windows vista';
    } else if (version.indexOf('Windows NT 6.1') !== -1) {
        return 'windows 7';
    } else if (version.indexOf('Windows NT 6.2') !== -1) {
        return 'windows 8';
    } else if (version.indexOf('Windows NT 10.0') !== -1) {
        return 'windows 10';
    }
    return false;
};

// ie9或者ie10或者或者win7的ie11，播放器相关的url要替换，参数也要替换
const useIEUrl = function () {
    const isNotWin10 = getWinVersion() !== 'windows 10';
    const IEVersion = detectIE();
    if ((IEVersion && IEVersion <= 10) || (IEVersion && isNotWin10)) {
        return true;
    }
    return false;
};
// ie9或者ie10或者或者win7的ie11，接口名包含video-sharp-info或者safe-new，替换为safe
const changeUrlForIE = function (url) {
    if (
        useIEUrl() &&
        url &&
        typeof url === 'string'
    ) {
        return url.replace('video-sharp-info', 'safe').replace('safe-new', 'safe');
    }
    return url;
};

export {
    detectIE,
    supportFlash,
    googleVersion,
    useIEUrl,
    getWinVersion,
    changeUrlForIE,

};
